import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NavigationStart, Router, RouterLink, RouterModule } from '@angular/router';
import { ReplaySubject, takeUntil } from 'rxjs';
import { RepairModeSearchComponent } from '../../components/repair-mode/repair-mode-search/repair-mode-search.component';
import { RepairModeFiltersComponent } from '../../components/repair-mode/repair-mode-filters/repair-mode-filters.component';
import { RepairModeGridComponent } from '../../components/repair-mode/repair-mode-grid/repair-mode-grid.component';
import { RepairModeFilterForm } from '../../form-model/repair-mode-filter.form.model';
import { RepairModeSearchTextForm } from '../../form-model/repair-mode-search-text.form.model';
import { RepairModeService } from '../../services/repair-mode.service';

@Component({
  selector: 'app-repair-mode-list',
  templateUrl: './repair-mode.component.html',
  styleUrl: './repair-mode.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    RouterModule,
    RepairModeSearchComponent,
    RepairModeFiltersComponent,
    RepairModeGridComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairModeListComponent implements OnInit, OnDestroy {
  filterFormGroup = this.formBuilder.group({
    repairModeFilterForm: this.formBuilder.group<RepairModeFilterForm>({} as RepairModeFilterForm),
    repairModeSearchTextForm: this.formBuilder.group<RepairModeSearchTextForm>({} as RepairModeSearchTextForm),
  });

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly repairModeService: RepairModeService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!event.url.startsWith('/master-data/repair-mode')) {
          this.repairModeService.setRepairModeFilterFormValue(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
